module.exports = __webpack_public_path__ + "static/sport/down-btn-bg.64fca42.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport7/down-btn-bg.png
// module id = OEXV
// module chunks = 0